export default __webpack_public_path__ + "static/media/jantar.5fe522a5.png";